(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.parserUtils = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * @typedef {function(string): T | null} Parser<T>
   * @memberof path
   * @private
   * @since 1.0.0
   */

  var maybeMap = function maybeMap(maybe, fn) {
    return maybe === null ? maybe : fn(maybe);
  };
  /**
   * Creates a parser from a regular expression by matching the input string with
   * the regular expression, returning the resulting match object.
   * @function
   * @memberof path
   * @param {RegExp} regexp the regular expression
   * @return {core.Parser<string[]>} the resulting parser
   * @private
   * @since 1.0.0
   */


  var regexp = exports.regexp = function regexp(_regexp) {
    return function (str) {
      return maybeMap(str.match(_regexp), function (match) {
        return match.slice(1);
      });
    };
  };
  /**
   * Returns a new parser that will return <code>null</code> if a predicate about
   * the result of another parser does not hold. If the predicate holds then
   * the new parser returns the result of the other parser unchanged.
   * @function
   * @memberof path
   * @param {core.Parser<T>} parser parser to filter
   * @param {function(*): boolean} predicate predicate to use
   * @return {core.Parser<T>} resulting parser
   * @private
   * @since 1.0.0
   */


  var filter = exports.filter = function filter(parser, predicate) {
    return function (str) {
      return maybeMap(parser(str), function (parsed) {
        return predicate(parsed) ? parsed : null;
      });
    };
  };
  /**
   * Returns a new parser which will post-process the result of another parser.
   * @function
   * @memberof path
   * @param {core.Parser<T>} parser parser for which to process the result
   * @param {function(T): R} mapper function to transform the result of the parser
   * @return {core.Parser<R>} resulting parser
   * @private
   * @since 1.0.0
   */


  var map = exports.map = function map(parser, mapper) {
    return function (str) {
      return maybeMap(parser(str), mapper);
    };
  };
  /**
   * Returns a new parser that attempts parsing with a first parser then falls
   * back to a second parser if the first returns <code>null</code>.
   * @function
   * @memberof path
   * @param {core.Parser<A>} parser the first parser
   * @param {core.Parser<B>} other the second parser
   * @return {core.Parser<A | B>} resulting parser
   * @private
   * @since 1.0.0
   */


  var fallback = exports.fallback = function fallback(parser, other) {
    return function (str) {
      var parsed = parser(str);
      if (parsed !== null) return parsed;
      return other(str);
    };
  };
  /**
   * Chains a list of parsers together using <code>fallback</code>.
   * @function
   * @memberof path
   * @param {Array<core.Parser<*>>} parsers a list of parsers to try in order
   * @return {core.Parser<*>} resulting parser
   * @private
   * @since 1.0.0
   */


  var race = exports.race = function race(parsers) {
    return parsers.reduce(function (chainedParser, parser) {
      return fallback(chainedParser, parser);
    });
  };
});